import { z } from 'zod';

import { ReversePaywallMonthlyPrefixLiterals, SubscriptionPeriodLiterals, ViewAllPlansColorLiterals } from './paywall';

export const PRESENTATION_OVERRIDE_ARM_PREFIX = 'override_';

export const SocialProofLayoutLiterals = z.enum(['none', 'checklist', 'horizontal_strip']);
export type SocialProofLayoutLiterals = z.infer<typeof SocialProofLayoutLiterals>;

export const paywallPresentationPayload = z.object({
  monthlyPricePrefix: ReversePaywallMonthlyPrefixLiterals.optional(),
  isRebranding: z.boolean().optional(),
  viewAllPlanCta: ViewAllPlansColorLiterals.optional(),
  videoPath: z.string().optional(),
  hideBackground: z.boolean().optional(),
  showReviewCarousel: z.boolean().optional(),
  socialProofLayout: SocialProofLayoutLiterals.optional(),
  enablePulse: z.boolean().optional(),
  pulseDuration: z.number().optional(),
  pulseScaleMin: z.number().optional(),
  pulseScaleMax: z.number().optional(),
  pulseGlowRgb: z.string().optional(),
  pulseGlowRadius: z.number().optional(),
});
export type PaywallPresentationPayload = z.infer<typeof paywallPresentationPayload>;

export const legacyPaywallTypeBasePeriodPayload = z.object({
  baseSubscriptionPeriod: SubscriptionPeriodLiterals.optional(),
  disableBaseSubscriptionPeriodOverrides: z.boolean().optional(),
});

export const presentationBaselineDefinition = {
  definition: paywallPresentationPayload
    .extend({ monthlyPricePrefix: ReversePaywallMonthlyPrefixLiterals })
    .extend(legacyPaywallTypeBasePeriodPayload.shape)
    .optional(),
  variants: z.string(),
};

export const presentationExperimentDefinition = <const Treatments extends readonly [string, ...string[]]>(
  ...treatments: Treatments
) => ({
  definition: paywallPresentationPayload.optional(),
  variants: z.enum(['control', ...treatments]),
});
